import * as React from 'react';
import {Menu, MenuItemProps} from "semantic-ui-react";

interface NumberOfItemsProps {
    numberOfItems: number;
    setNumberOfItems: (e: React.MouseEvent<HTMLAnchorElement>, data: MenuItemProps) => void;
    dataLength: number;
    filteredDataLength: number;
    t: reactI18Next.TranslationFunction;
    customNoOfItems?: number[];
    isNewTable?: boolean;
    records?: number;
    filterCount?: number;
}

const NumberOfItems: React.SFC<NumberOfItemsProps> = (props: NumberOfItemsProps) => {
    const lowNoOfItems = props.customNoOfItems ? props.customNoOfItems[0] : 10;
    const middleNoOfItems = props.customNoOfItems ? props.customNoOfItems[1] : 20;
    const highNoOfItems = props.customNoOfItems ? props.customNoOfItems[2] : 50;
    return (
        <div>
            {!props.isNewTable && <Menu
                pagination={true}
                className='table-pagination-menu'
            >
                <Menu.Item
                    name={lowNoOfItems.toString()}
                    value={lowNoOfItems}
                    active={props.numberOfItems === lowNoOfItems}
                    onClick={props.setNumberOfItems}
                />
                <Menu.Item
                    name={middleNoOfItems.toString()}
                    value={middleNoOfItems}
                    active={props.numberOfItems === middleNoOfItems}
                    onClick={props.setNumberOfItems}
                />
                <Menu.Item
                    name={highNoOfItems.toString()}
                    value={highNoOfItems}
                    active={props.numberOfItems === highNoOfItems}
                    onClick={props.setNumberOfItems}
                />
                <Menu.Item
                    name={props.t('GLOBAL:ALL')}
                    value={props.dataLength}
                    active={props.numberOfItems === props.dataLength}
                    onClick={props.setNumberOfItems}
                />
            </Menu>}
            {!props.isNewTable && <div className='table-pagination-items-count'>{props.t("NR_ITEMS", {length: props.filteredDataLength})}</div>}
            {props.isNewTable && (
                <div className="table-pagination-items-count" style={{display: 'flex',alignItems: 'center',gap: '16px',fontSize: '1em',fontWeight: 500}}>
                    <span>
                        <span style={{color: '#2185d0', fontWeight: 700}}>{props.records}</span>
                        <span style={{margin: '0 4px', color: '#888'}}>/</span>
                        <span style={{color: '#21ba45', fontWeight: 700}}>{props.filterCount}</span>
                    </span>
                    <span style={{background: '#f3f4f5',borderRadius: '12px',padding: '2px 10px',color: '#333',fontSize: '0.95em',marginLeft: '8px'}}>
                        Total: <b>{props.filteredDataLength}</b>
                    </span>
                </div>
            )}
        </div>
    );
};

export default NumberOfItems;



// WEBPACK FOOTER //
// ./src/components/Table/components/footerComponents/pagination/NumberOfItems.tsx